import React from "react";

import { AccountsRecipientIcon } from "components/Icons/AccountsRecipientIcon";
import { CommercialEmailRecipientIcon } from "components/Icons/CommercialEmailRecipientIcon";
import { ComplianceEmailRecipientIcon } from "components/Icons/ComplianceEmailRecipientIcon";
import { Row } from "components/Layout";

export const EmailRecipientIconList = ({ recipient }) => {
  return (
    <Row alignCenter>
      {recipient.isAccountsRecipient ? (
        <AccountsRecipientIcon fontSize="delta" />
      ) : null}
      {recipient.isCommercialReportRecipient || recipient.isCommercialUser ? (
        <CommercialEmailRecipientIcon fontSize="delta" />
      ) : null}
      {recipient.isComplianceReportRecipient || recipient.isComplianceUser ? (
        <ComplianceEmailRecipientIcon fontSize="delta" />
      ) : null}
    </Row>
  );
};
